import { Paper } from '@material-ui/core';
import * as React from 'react';
import { useSegmentsFiltersAdmin } from '../../hooks/useSegmentsFilters';
import { SegmentFiltersAdmin } from '../../models/segments';
import { TableSortState } from '../../models/tableSortState';
import SegmentsSidebar from './filter-sidebar/segments-sidebar';
import SegmentsTable from './overview/segments-table';
import { clientSegmentsHeaders, defaultActiveFilters } from './segments';
import * as styles from './segments.module.scss';

export enum SegmentSortFields {
  Team = 'clientName',
  Name = 'name',
  LastModified = 'lastModifiedDate',
  CreatedBy = 'createdByName',
  Customers = 'customers',
  Sharing = 'isShared'
}

const defaultActiveFiltersAdmin: SegmentFiltersAdmin = {
  ...defaultActiveFilters,
  teams: []
};

const adminSegmentsHeaders = [
  {
    title: 'Team',
    orderField: SegmentSortFields.Team
  },
  ...clientSegmentsHeaders
];

const initialSortState: TableSortState = {
  page: 1,
  pageSize: 15,
  orderColumn: SegmentSortFields.LastModified,
  orderDirection: 'desc'
};

/**
 * In admin/management portal, view table of all created segments by any user
 */
const AdminSegments = () => {
  const [activeFilters, setActiveFilters] = React.useState<SegmentFiltersAdmin>(defaultActiveFiltersAdmin);
  const filtersQuery = useSegmentsFiltersAdmin();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1>Segments</h1>
      </div>
      <Paper elevation={1} className={styles.paper}>
        <SegmentsSidebar
          setActiveFilters={setActiveFilters as (filters: SegmentFiltersAdmin) => void}
          defaultActiveFilters={defaultActiveFiltersAdmin}
          isLoading={filtersQuery.isLoading}
          loadedFilters={filtersQuery.data}
        />
        <SegmentsTable
          columnHeaders={adminSegmentsHeaders}
          initialSortState={initialSortState}
          activeFilters={activeFilters}
        />
      </Paper>
    </div>
  );
};

export default AdminSegments;
